<template>
    <div class="buy_box_v1 flex_box center">
      <div class="free">
        <p class="title">{{$t("Free")}}</p>
        <p class="price"><sup>$</sup>0<span></span></p>
        <span class="btn">{{$t("GetStarted")}}</span>
        <dl>
          <dt>{{$t("AccessTo")}}</dt>
          <dd><span class="red">2</span> {{$t("imagesOfwatermarkremoval")}}</dd>
          <dd>{{$t("upTo")}} <span>10MB</span> {{$t("perImage")}}</dd>
          <dd>{{$t("Support")}} <span>1920 x 1920</span> {{$t("resolution")}}</dd>
        </dl>
      </div>
      <div class="day">
        <p class="title">{{$t("dayPlan")}}</p>
        <div class="price_box">
          <p class="price active"><sup>$</sup>19.90<span class="tax">({{$t("TaxIncl")}})</span></p>
        </div>
        <div class="btn_box">
          <span plan="2" class="btn active">{{$t("Checkout")}}</span>
        </div>
        <ul class="lable">
          <li class="flex_box active"><span>500 {{$t("imagesDay")}}</span><span>$0.040/{{$t("image")}}</span></li>
        </ul>
        <dl>
          <dt>{{$t("AccessTo")}}</dt>
          <dd><span class="red_box"><span class="active">5</span><span>500</span></span> {{$t("imagesOfwatermarkremoval")}}</dd>
          <dd><span>{{$t("Unlimited")}}</span> {{$t("imageSize")}}</dd>
          <dd>{{$t("Support")}} <span>12K</span> {{$t("resolution")}}</dd>
          <dd v-html="this.$t('buyInfo1')"></dd>
          <dd>{{$t("buyInfo2")}}</dd>
          <dd>{{$t("buyInfo3")}}</dd>
          <dd>{{$t("buyInfo4")}}</dd>
          <dd>{{$t("buyInfo5")}}</dd>
          <dd>{{$t("buyInfo6")}}</dd>
        </dl>
      </div>
      <div class="month">
        <p class="title">Monthly</p>
        <div class="price_box">
          <p class="price active"><sup>$</sup>4.90<span class="tax">({{$t("TaxIncl")}})</span></p>
          <p class="price"><sup>$</sup>9.90<span class="tax">({{$t("TaxIncl")}})</span></p>
          <p class="price"><sup>$</sup>17.90<span class="tax">({{$t("TaxIncl")}})</span></p>
          <p class="price"><sup>$</sup>39.90<span class="tax">({{$t("TaxIncl")}})</span></p>
          <p class="price"><sup>$</sup>69.90<span class="tax">({{$t("TaxIncl")}})</span></p>
          <p class="price"><sup>$</sup>299.90<span class="tax">({{$t("TaxIncl")}})</span></p>
        </div>
        <div class="btn_box">
          <span plan="3" class="btn active">{{$t("Checkout")}}</span>
          <span plan="4" class="btn">{{$t("Checkout")}}</span>
          <span plan="5" class="btn">{{$t("Checkout")}}</span>
          <span plan="6" class="btn">{{$t("Checkout")}}</span>
          <span plan="7" class="btn">{{$t("Checkout")}}</span>
          <span plan="8" class="btn">{{$t("Checkout")}}</span>
        </div>
        <ul class="lable">
          <li class="flex_box active"><span>50 {{$t("imagesMonthly")}}</span><span>$0.980/{{$t("image")}}</span></li>
          <li class="flex_box"><span>100 {{$t("imagesMonthly")}}</span><span>$0.099/{{$t("image")}}</span></li>
          <li class="flex_box"><span>200 {{$t("imagesMonthly")}}</span><span>$0.090/{{$t("image")}}</span></li>
          <li class="flex_box"><span>500 {{$t("imagesMonthly")}}</span><span>$0.080/{{$t("image")}}</span></li>
          <li class="flex_box"><span>1000 {{$t("imagesMonthly")}}</span><span>$0.070/{{$t("image")}}</span></li>
          <li class="flex_box"><span>{{$t("Unlimited")}} {{$t("imagesMonthly")}}</span><span></span></li>
        </ul>
        <dl>
          <dt>{{$t("AccessTo")}}</dt>
          <dd><span class="red_box"><span class="active">50</span><span>100</span><span>200</span><span>500</span><span>1000</span><span>{{$t("Unlimited")}}</span></span> {{$t("imagesOfwatermarkremoval")}}</dd>
          <dd><span>{{$t("Unlimited")}}</span> {{$t("imageSize")}}</dd>
          <dd>{{$t("Support")}} <span>12K</span> {{$t("resolution")}}</dd>
          <dd v-html="this.$t('buyInfo1')"></dd>
          <dd>{{$t("buyInfo2")}}</dd>
          <dd>{{$t("buyInfo3")}}</dd>
          <dd>{{$t("buyInfo4")}}</dd>
        </dl>
      </div>
      <div class="lifetime">
        <p class="title">{{$t("Lifetime")}}</p>
        <div class="price_box">
          <p class="price active"><sup>$</sup>19.90<span class="tax">({{$t("TaxIncl")}})</span></p>
          <p class="price"><sup>$</sup>39.90<span class="tax">({{$t("TaxIncl")}})</span></p>
          <p class="price"><sup>$</sup>69.90<span class="tax">({{$t("TaxIncl")}})</span></p>
          <p class="price"><sup>$</sup>149.90<span class="tax">({{$t("TaxIncl")}})</span></p>
          <p class="price"><sup>$</sup>249.90<span class="tax">({{$t("TaxIncl")}})</span></p>
        </div>
        <div class="btn_box">
          <span plan="9" class="btn active">{{$t("Checkout")}}</span>
          <span plan="10" class="btn">{{$t("Checkout")}}</span>
          <span plan="11" class="btn">{{$t("Checkout")}}</span>
          <span plan="12" class="btn">{{$t("Checkout")}}</span>
          <span plan="13" class="btn">{{$t("Checkout")}}</span>
        </div>
        <ul class="lable">
          <li class="flex_box active"><span>50 {{$t("images")}}</span><span>$0.398/{{$t("image")}}</span></li>
          <li class="flex_box"><span>100 {{$t("images")}}</span><span>$0.399/{{$t("image")}}</span></li>
          <li class="flex_box"><span>200 {{$t("images")}}</span><span>$0.350/{{$t("image")}}</span></li>
          <li class="flex_box"><span>500 {{$t("images")}}</span><span>$0.300/{{$t("image")}}</span></li>
          <li class="flex_box"><span>1000 {{$t("images")}}</span><span>$0.250/{{$t("image")}}</span></li>
        </ul>
        <dl>
          <dt>{{$t("AccessTo")}}</dt>
          <dd><span class="red_box"><span class="active">50</span><span>100</span><span>200</span><span>500</span><span>1000</span></span> {{$t("imagesOfwatermarkremoval")}}</dd>
          <dd><span>{{$t("Unlimited")}}</span> {{$t("imageSize")}}</dd>
          <dd>{{$t("Support")}} <span>12K</span> {{$t("resolution")}}</dd>
          <dd v-html="this.$t('buyInfo1')"></dd>
          <dd>{{$t("buyInfo2")}}</dd>
          <dd>{{$t("buyInfo3")}}</dd>
          <dd>{{$t("buyInfo4")}}</dd>
          <dd>{{$t("buyInfo7")}}</dd>
        </dl>
      </div>
    </div>
</template>
<script>
export default {
    mounted(){
        $('.buy_box_v1 .free .btn').click(function(){
            $('.maskRights').hide();
        })
        $('.buy_box_v1>div .lable li').click(function(){
            $(this).addClass('active').siblings().removeClass('active')
            $(this).parent().parent().find('.price_box').children().eq($(this).index()).addClass('active').siblings().removeClass('active')
            $(this).parent().parent().find('.btn_box').children().eq($(this).index()).addClass('active').siblings().removeClass('active')
            $(this).parent().parent().find('.red_box').children().eq($(this).index()).addClass('active').siblings().removeClass('active')
        })
        // 购买
        if(location.hostname=='www.anymp4.com'){
            var paddle_vendor=137567;
        }else{
            Paddle.Environment.set('sandbox');
            var paddle_vendor=570;
        }
        Paddle.Setup({
            vendor: paddle_vendor,
            eventCallback: function(data) {
                console.log(data);
                $('.buy_box .btn').removeClass('load');
                if (data.event === 'Checkout.PaymentComplete') {
                    isbuy=1;
                }
                if(data.event === 'Checkout.Close'&&isbuy){
                    $('.maskRights').show();
                    $('.buySuccess').show().siblings().hide();
                    if(getCookie('user')){
                        $('.buySuccess .Member').show().siblings('.info').hide();
                    }else{
                        $('.buySuccess .noMember').show().siblings('.info').hide();
                    }
                }
            }
        });
        $('.btn_box .btn').click(function(){
            if($(this).attr('class').indexOf('load')>-1){
                return false;
            }
            checkout($(this));
        })
        function checkout(that){
            var data={
                e_id:murmur,
                gateway:gateway,
                plan_id:that.attr('plan'),
            }
            that.addClass('load')
            $.post(
                post_url+"subscription/checkout",
                data,
                function(data){
                    that.removeClass('load')
                    error_fn(data.error,that);
                    switch(data.error){
                        case 0:
                            if(gateway==4){
                                // 2checkout
                                (function (document, src, libName, config,data) {
                                    var data=getUrlkey(data.url_gateway)
                                    var script             = document.createElement('script'); 
                                    script.src             = src; 
                                    script.async           = true; 
                                    script.id              ='buy2checkout'
                                    var firstScriptElement = document.getElementsByTagName('script')[0]; 
                                    script.onload          = function () {
                                        var isbuy=0;
                                        for (var namespace in config) {
                                            if (config.hasOwnProperty(namespace)) {
                                                window[libName].setup.setConfig(namespace, config[namespace]);
                                            } 
                                        } 
                                        window[libName].register();
                                        TwoCoInlineCart.products.add({
                                            code: data.prod,
                                            quantity: data.qty,
                                        });
                                        try{
                                            if(data.test){
                                                TwoCoInlineCart.cart.setTest(true);
                                            }
                                        }catch(e){
                                            console.log(e)
                                        }
                                        if(data.lock){
                                            TwoCoInlineCart.cart.setCartLockedFlag(true)
                                        }else{
                                            TwoCoInlineCart.cart.setCartLockedFlag(false);
                                        }
                                        if(data['empty-cart']){
                                            TwoCoInlineCart.cart.setReset(true)
                                        }else{
                                            TwoCoInlineCart.cart.setReset(false)
                                        }
                                        TwoCoInlineCart.cart.setExpiration(data.expiration)
                                        TwoCoInlineCart.cart.setSignature(data.signature)
                                        // TwoCoInlineCart.cart.setOrderExternalRef(data['order-ext-ref'])
                                        TwoCoInlineCart.cart.setExternalCustomerReference(data['customer-ext-ref'])
                                        TwoCoInlineCart.cart.checkout();
                                        TwoCoInlineCart.events.subscribe('cart:opened', function () {
                                            console.log('cart:opened')
                                        })
                                        TwoCoInlineCart.events.subscribe('cart:closed', function () {
                                            if(isbuy){
                                                $('.maskRights').show();
                                                if(getCookie('user')){
                                                    $('.buySuccess.Member').show().siblings().hide();
                                                    gaPush('buy_login','true')
                                                }else{
                                                    $('.buySuccess.noMember').show().siblings().hide();
                                                    gaPush('buy_login','false')
                                                }
                                            }
                                        })
                                        TwoCoInlineCart.events.subscribe('payment:finalized', function () {
                                            isbuy=1;
                                            gaPush('buy_success','')
                                        })
                                    }; 
                                    firstScriptElement.parentNode.insertBefore(script, firstScriptElement); 
                                })(document, 'https://secure.2checkout.com/checkout/client/twoCoInlineCart.js', 'TwoCoInlineCart',{"app":{"merchant":getUrlkey(data.url_gateway).merchant,"iframeLoad":"checkout"},"cart":{"host":"https:\/\/secure.2checkout.com","customization":"inline"}},data); 
                            }else{
                                isbuy=0;
                                Paddle.Checkout.open({
                                    override: data.url_gateway
                                });
                            }
                            break
                        case 25301:
                            that.removeClass('load')
                            error(i18n[lang].error_25301);
                            break;
                        case 25302:
                            that.removeClass('load')
                            error(i18n[lang].error_25302);
                            break;
                        case 25303:
                            that.removeClass('load')
                            error(i18n[lang].error_25303);
                            break;
                        case 25304:
                            that.removeClass('load')
                            error(i18n[lang].error_25304);
                            break;
                        case 25305:
                            that.removeClass('load')
                            error(i18n[lang].error_25305);
                            break;
                        case 25306:
                            that.removeClass('load')
                            error(i18n[lang].error_25306);
                            break;
                    }
                }
            ).fail(function(xhr){
                overtime(25399);
            });
        }
        // url参数解析
        function getUrlkey(url) {
            var params = {};
            var urls = url.split("?");
            var arr = urls[1].split("&");
            for (var i = 0, l = arr.length; i < l; i++) {
            var a = arr[i].split("=");
            params[a[0]] = a[1];
            }
            return params;
        }
    }
}
</script>
<style scoped>
    .buy_box_v1{text-align: center;margin: auto;max-width: 1200px;}
    .buy_box_v1>div{max-width: 290px;width: 100%;box-shadow: 0px 2px 11px 0px rgba(0,0,0,0.07);border-radius: 8px;border: 1px solid #eee;background: #fff;padding-top: 19px;border-top: 9px solid #F8D182;padding: 20px 16px 60px;box-sizing: border-box;}
    .buy_box_v1>div.free .btn{border: 1px solid #DE3E3E;background: #fff;box-sizing: border-box;line-height: 52px;color: #DE3E3E;}
    .buy_box_v1>div.day{border-top-color: #CC79F3;}
    .buy_box_v1>div.month{border-top-color: #FF9970;position: relative;}
    .buy_box_v1>div.month::after{clear: both;content: "";width: 161px;height: 74px;background: url(../assets/images/best.svg);position: absolute;left: -1px;top: -38px;}
    .buy_box_v1>div.lifetime{border-top-color: #58DB9C;}
    .buy_box_v1>div .title{font-size: 24px;line-height: 36px;color: #222;font-weight: bold;}
    .buy_box_v1>div .price{font-size: 46px;color: #222;font-weight: bold;line-height: 46px;margin-top: 30px;}
    .buy_box_v1>div .price sup{font-size: 20px;margin-right: 8px;}
    .buy_box_v1>div .price .tax{font-size: 14px;font-weight: bold;line-height: 16px;}
    .buy_box_v1>div .price_box .price{display: none;}
    .buy_box_v1>div .price_box .price.active{display: block;}
    .buy_box_v1>div .btn{min-width: 230px;height: 54px;line-height: 54px;font-size: 20px;font-weight: bold;color: #fff;background: #DE3E3E;box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.25);border-radius: 10px;display: inline-block;margin: auto;box-sizing: border-box;padding-left: 10px;padding-right: 10px;margin-top: 40px;cursor: pointer;position: relative;text-decoration: none;}
    .buy_box_v1>div .btn.load::after{clear: both;content: "";width: 16px;height: 16px;background: url(../assets/images/loading.svg);position: absolute;top: 19px;margin-left: 6px;-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;}
    .buy_box_v1>div .btn_box .btn{display: none;}
    .buy_box_v1>div .btn_box .btn.active{display: inline-block;}
    .buy_box_v1>div .lable{margin-top: 60px;}
    .buy_box_v1>div .lable li{font-size: 14px;color: #333;margin-bottom: 14px;padding-left: 20px;position: relative;cursor: pointer;}
    .buy_box_v1>div .lable li::after{clear: both;content: "";width: 16px;height: 16px;border: 1px solid #777;box-sizing: border-box;position: absolute;border-radius: 50%;top: 2px;left: 0px;}
    .buy_box_v1>div .lable li.active::before{clear: both;content: "";width: 10px;height: 10px;background: #18B76B;border-radius: 50%;position: absolute;top: 5px;left: 3px;}
    .buy_box_v1>div .lable li.active::after{border-color: #18B76B;}
    .buy_box_v1>div .lable li:last-child{margin-bottom: 0px;}
    .buy_box_v1>div .lable li span:last-child{font-weight: bold;}
    .buy_box_v1>div dl{margin-top: 40px;border-top: 1px solid #eee;padding-top: 40px;text-align: left;}
    .buy_box_v1>div dl dt{font-size: 18px;color: #222;font-weight: bold;line-height: 24px;}
    .buy_box_v1>div dl dd{margin-top: 14px;font-size: 16px;color: #333;line-height: 30px;padding-left: 15px;position: relative;}
    .buy_box_v1>div dl dd::after{clear: both;content: "";width: 5px;height: 5px;position: absolute;top: 14px;left: 0px;background: #333;border-radius: 50%;}
    .buy_box_v1>div dl dd>span{font-weight: bold;}
    .buy_box_v1>div dl dd span.red,.buy_box_v1>div dl dd span.red_box{color: #DE3E3E;}
    .buy_box_v1>div dl dd span.red_box span{display: none;}
    .buy_box_v1>div dl dd span.red_box span.active{display: inline-block;}
    @media screen and (max-width:1200px){
        .buy_box_v1{max-width: 600px !important;}
        .buy_box_v1>div{max-width: 100%;margin-bottom: 40px;-webkit-order: 1;order: 1;}
        .buy_box_v1>div.free{-webkit-order: 2;order: 2;}
        .buy_box_v1>div dl,.buy_box_v1>div .lable{max-width: 330px;margin-left: auto;margin-right: auto;}
    }
    @media screen and (max-width:630px){
        .maskRights .maskRightsBuyBox .scroll_box{padding-left: 20px;padding-right: 10px;}
    }
</style>